import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../../config';

const HeadersList = ({ fields, className, showMaxLimit }) => (
  <div className={className}>
    <p className="u-mb-" display-if={showMaxLimit}>
      Maximum of <strong>{config.importLimit}</strong> entries can be imported at once.
    </p>
    Header must be present in csv, following columns are accepted(* for required):
    <ul className="u-ml">
      {
        fields.map(field => <li key={field}>{field}</li>)
      }
    </ul>
  </div>
);

HeadersList.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.array.isRequired,
  showMaxLimit: PropTypes.bool,
};

HeadersList.defaultProps = {
  className: '',
  showMaxLimit: false,
};

export default HeadersList;
